import React from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import DownloadIcon from '@mui/icons-material/Download';

import { TooltipedActionButton, TooltipedDropdownButton } from 'src/App/Components/Buttons';
import { User } from 'src/interfaces/iuser';
import { callApi } from 'src/core/callApi';

const ActionToolsBar = ({ setShowListingsExportPage, handleOnSampleClick }) => {
  const user: User = useSelector((state: any) => state.dashboard.user);
  const search = useSelector((state: any) => state.dashboard.search);

  const handleSaveClick = () => {
    if (user.subscriptionPlan == 'scale') {
      saveMarket();
      return;
    }
    window.open('/advanced-dashboard', '_blank');
  };

  const saveMarket = async () => {
    if (user.subscriptionPlan != 'scale') {
      return;
    }
    const URL = 'https://iknejeg0yj.execute-api.us-east-2.amazonaws.com/default/saveAdvancedMarket';
    const res = await callApi(
      URL,
      {
        queryParams: {
          id: search.data.id,
          name: search.data.name,
          city: search.data.city,
          countryCode: search.data.countryCode,
        },
      },
      true
    );
    if (res.message == 'success') {
      window.alert('Market is saved successfully!');
    }
  };

  const handleDownloadMarketSummarySampleClick = () => {
    const downloadUrl =
      'https://airbtics-resource.s3.us-east-2.amazonaws.com/Airbtics-Sample-Market-Summary.csv';
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'Airbtics-Sample-Market-Summary.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubscribeToScaleClick = () => {
    handleOnSampleClick('scale');
  };

  const handleDownloadListingLevelClick = () => {
    setShowListingsExportPage(true);
  };

  const downloadOptions = [
    { label: 'Download Sample', onClick: handleDownloadMarketSummarySampleClick },
    { label: 'Subscribe to Scale', onClick: handleSubscribeToScaleClick },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'flex-start',
        backgroundColor: '#f5f5f5',
        borderRadius: '12px',
        padding: '10px 20px',
        width: 'fit-content',
        margin: '0 auto',
        gap: '10px',
      }}
    >
      <TooltipedActionButton
        title="Save markets to track key metrics and export to Excel. Only available on Scale plan."
        onClick={handleSaveClick}
        icon={FavoriteBorderIcon}
        label="Save"
      />

      {user.subscriptionPlan != 'scale' ? (
        <TooltipedDropdownButton
          title="Export key metrics of this market to Excel. Only available on Scale plan."
          icon={DownloadIcon}
          label="Market Summary"
          options={downloadOptions}
          smallLabel={true}
        />
      ) : (
        <TooltipedActionButton
          title="Export key metrics of this market to Excel."
          onClick={() => {}} // TODO: implement this
          icon={DownloadIcon}
          label="Market Summary"
          smallLabel={true}
        />
      )}

      <TooltipedActionButton
        title="Download all the data on short-term rental listings in this market. This is an add-on product. It is not included in any of the subscription plans. Purchase it now."
        onClick={handleDownloadListingLevelClick}
        icon={DownloadIcon}
        label="Listing Level"
        smallLabel={true}
      />
    </Box>
  );
};

export default ActionToolsBar;
